import { FC } from "react";
import { MDBBtn } from "mdb-react-ui-kit";
import contactsSvg from "@/utils/svg-icon/contacts";
import style from "../../../../styles/navbar/NavBarM.module.scss";

interface NavBarMActionBtnProps {
    ctaButtonText?: string;
    ctaButtonUrl?: string;
}

const NavBarMActionBtn: FC<NavBarMActionBtnProps> = ({
    ctaButtonText,
    ctaButtonUrl,
}) => {
    const handleClick = () => {
        if (ctaButtonUrl) {
            window.open(ctaButtonUrl, "_blank");
        }
    };

    // Mostra il bottone solo se entrambi i valori CMS sono presenti
    if (!ctaButtonText || !ctaButtonUrl) {
        return null;
    }

    return (
        <MDBBtn
            outline
            rounded
            color="white"
            className={`${style.navBarMActionBtn} ${style.navBarMParagraph} align-self-center p-2`}
            size="sm"
            type="button"
            id="navigate-tours"
            onClick={handleClick}
        >
            {ctaButtonText}
            <contactsSvg.PencilLine className={`${style.svg} ms-1`} alt="" />
        </MDBBtn>
    );
};

export default NavBarMActionBtn;
